import APIService from '@/api'

export default class APICustomer extends APIService{

    constructor(){
        super('home')
    }

    submitPriceRequest(item, token) {
        return this.AxiosInstance.post(this.ApiUrl + "/submitpricerequest", item, { });
    }
}


// WEBPACK FOOTER //
// ./src/api/home.js